import React from 'react';
import PropTypes from 'prop-types';

export const Badge = ({ width, height, ...props }) => (
  <svg
    data-icon='badge'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20V9c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 7h5V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 11 2h2c.55 0 1.02.196 1.412.587C14.804 2.98 15 3.45 15 4v3h5c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v11c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22H4Zm0-2h16V9h-5c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 13 11h-2c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 9 9H4v11Zm2-2h6v-.45c0-.283-.08-.546-.238-.788a1.57 1.57 0 0 0-.662-.562 5.158 5.158 0 0 0-1.012-.337A5.063 5.063 0 0 0 9 15.75c-.383 0-.746.037-1.088.113-.341.075-.679.187-1.012.337a1.57 1.57 0 0 0-.663.563A1.41 1.41 0 0 0 6 17.55V18Zm8-1.5h4V15h-4v1.5ZM9 15c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 9 12c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 7.5 13.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437Zm5-1.5h4V12h-4v1.5ZM11 9h2V4h-2v5Z'
    />
  </svg>
);

Badge.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Badge.defaultProps = {
  width: 24,
  height: 24,
};
